import { ThemeOptions } from '@mui/material/styles';

/**
 * Base theme configuration shared across all themes.
 * Contains typography, spacing, shape, and compact component defaults.
 * Individual themes override palette and theme-specific component styles.
 */
export const baseTypography: ThemeOptions['typography'] = {
    fontSize: 12,
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
    ].join(','),
    h1: {
        fontSize: '1.75rem',
        fontWeight: 600,
    },
    h2: {
        fontSize: '1.5rem',
        fontWeight: 600,
    },
    h3: {
        fontSize: '1.25rem',
        fontWeight: 600,
    },
    h4: {
        fontSize: '1.125rem',
        fontWeight: 600,
    },
    h5: {
        fontSize: '1rem',
        fontWeight: 600,
    },
    h6: {
        fontSize: '0.875rem',
        fontWeight: 600,
    },
    body1: {
        fontSize: '0.8125rem',
    },
    body2: {
        fontSize: '0.75rem',
    },
    button: {
        fontSize: '0.8125rem',
    },
    caption: {
        fontSize: '0.6875rem',
    },
};

export const baseSpacing = 6;

export const baseShape: ThemeOptions['shape'] = {
    borderRadius: 4,
};

/** Compact component defaults shared by dark and default themes */
export const baseComponents: ThemeOptions['components'] = {
    MuiButton: {
        defaultProps: {
            size: 'small',
        },
        styleOverrides: {
            root: {
                textTransform: 'none',
                fontWeight: 500,
                minHeight: 28,
                padding: '4px 12px',
            },
            sizeSmall: {
                minHeight: 24,
                padding: '2px 8px',
                fontSize: '0.75rem',
            },
        },
    },
    MuiIconButton: {
        defaultProps: {
            size: 'small',
        },
        styleOverrides: {
            root: {
                padding: 4,
            },
        },
    },
    MuiTextField: {
        defaultProps: {
            size: 'small',
        },
        styleOverrides: {
            root: {
                '& .MuiInputBase-input': {
                    padding: '6px 10px',
                    fontSize: '0.8125rem',
                },
            },
        },
    },
    MuiInputBase: {
        styleOverrides: {
            root: {
                fontSize: '0.8125rem',
            },
        },
    },
    MuiSelect: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiFormControl: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiChip: {
        defaultProps: {
            size: 'small',
        },
        styleOverrides: {
            root: {
                height: 22,
                fontSize: '0.75rem',
            },
        },
    },
    MuiCardContent: {
        styleOverrides: {
            root: {
                padding: 12,
                '&:last-child': {
                    paddingBottom: 12,
                },
            },
        },
    },
    MuiTableCell: {
        styleOverrides: {
            root: {
                padding: '4px 8px',
                fontSize: '0.8125rem',
            },
            head: {
                fontWeight: 600,
                padding: '6px 8px',
            },
        },
    },
    MuiToolbar: {
        styleOverrides: {
            root: {
                minHeight: '40px !important',
            },
        },
    },
    MuiDialogTitle: {
        styleOverrides: {
            root: {
                padding: '12px 16px',
                fontSize: '1rem',
            },
        },
    },
    MuiDialogContent: {
        styleOverrides: {
            root: {
                padding: '12px 16px',
            },
        },
    },
    MuiMenuItem: {
        styleOverrides: {
            root: {
                fontSize: '0.8125rem',
                minHeight: 32,
            },
        },
    },
};
